import Axios, { AxiosResponse } from "axios"
import { EncryptionKeys } from "controllers/EncryptionController"
import { encryptionGCMHelper } from "helpers/encryption-gcm"
import { getPrivateKeyByUserId } from "helpers/utils"
import { isArray, isUndefined } from "lodash"
import {
  BuildConversationDetail,
  ParamsBuildConversationProps,
} from "pages/conversations/conversations.type"
import { KeyEncryptionType } from "types"

export const getListBuildMiddleware = async (
  urlTab: string,
  params?: ParamsBuildConversationProps
) => {
  const response: AxiosResponse<{
    data: BuildConversationDetail[]
    projectKeys: any,
    buildKeys: any
  }> = await Axios.get(`/api/conversation/build/${urlTab}`, { params })
  const userVaultKey = localStorage.getItem(
    EncryptionKeys.userVaultKey
  ) as string
  const projectEncryptionKeys = JSON.parse(
    localStorage.getItem(EncryptionKeys.projectEncryptionKeys) || "{}"
  )
  const privateKeyPem: any = await getPrivateKeyByUserId()
  const decryptRSA = (value?: string): string => {
    if (!value) return ''
    try {
      return privateKeyPem.decrypt(value, 'RSA-OAEP')
    } catch {
      return ''
    }
  }

  const decryptGCM = async (key: string, value?: string): Promise<string> => {
    if (!value) return ''
    try {
      return await encryptionGCMHelper.decryptContext(key, value)
    } catch {
      return ''
    }
  }
  if (!isUndefined(response.data.projectKeys) && isArray(response.data.projectKeys) && response.data.projectKeys.length) {
    for (const project of response.data.projectKeys) {
      let projectKey = ''
      if (project.type === KeyEncryptionType.ProjectShareKey) {
        projectKey = decryptRSA(project.encrypted_key)
      } else {
        projectKey = await decryptGCM(userVaultKey, project.encrypted_key)
      }
      if (projectKey) {
        projectEncryptionKeys[project.projectId] = projectKey
      }
    }
    localStorage.setItem(
      EncryptionKeys.projectEncryptionKeys,
      JSON.stringify(projectEncryptionKeys)
    )
  }
  if (!isUndefined(response.data.buildKeys) && isArray(response.data.buildKeys) && response.data.buildKeys.length) {
    const buildAdditionalInfoEncryptionKeys = JSON.parse(
      localStorage.getItem(EncryptionKeys.buildAdditionalInfoEncryptionKeys) ||
      "{}"
    )
    for (const build of response.data.buildKeys) {
      let buildKey = ''
      if (build.additional_id) {
        const projectKeyByAdditionalId = projectEncryptionKeys[build.additional_id]
        if (projectKeyByAdditionalId) {
          buildKey = await decryptGCM(
            projectKeyByAdditionalId,
            build.encrypted_key
          )
        }
        if (!buildKey) {
          buildKey = decryptRSA(build.encrypted_key)
        }
        if (buildKey) {
          buildAdditionalInfoEncryptionKeys[build.project_build_id] = buildKey
        }
      }
    }
    localStorage.setItem(
      EncryptionKeys.buildAdditionalInfoEncryptionKeys,
      JSON.stringify(buildAdditionalInfoEncryptionKeys)
    )
  }
  return response.data.data
}

export const updateUnlistedComponentInBuildMiddleware = async (
  projectBuildComponentId: string,
  log: string
) => {
  const response = await Axios.put(
    `/api/project-build/component/${projectBuildComponentId}/unlisted`,
    {
      log,
    }
  )
  return response.data.data
}
